import React from "react";
import { Link } from "react-router-dom";
import "./orgSignup.scss";
import { KapOrgIcon2 } from "../../../assets/icons";
import { useTranslation } from "../../../i18n/LanguageContext";

function FinalStepOrg() {
   const { t } = useTranslation();

   return (
      <div className="kap-org-done">
         <Link to="/" className="kap-org-done__logo">
            <img src={KapOrgIcon2} alt="KAPorg" />
         </Link>
         <div className="kap-org-done__card">
            <svg width="22" height="22" viewBox="0 0 24 24" fill="none" aria-hidden="true">
               <path
                  d="M4 13.5V18a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-4.5M4 13.5 6.2 6.4A2 2 0 0 1 8.1 5H9m-5 8.5h4l1.5 2.5h5l1.5-2.5h4m0 0-2.2-7.1A2 2 0 0 0 15.9 5H15M12 3v8m0 0-3-3m3 3 3-3"
                  stroke="#4158CF"
                  strokeWidth="1.4"
                  strokeLinecap="round"
                  strokeLinejoin="round"
               />
            </svg>
            <h1 className="kap-org-done__title">{t("got-your-application-title")}</h1>
            <p className="kap-org-done__subtitle">{t("confirmation-email-shortly-text")}</p>
            <Link to="/" className="btn sign-btn font-weight-bold kap-org-done__button">
               {t("go-to-homepage-button")}
            </Link>
            <p className="kap-org-done__help">
               {t("didnt-get-email-text")}{" "}
               <a href="mailto:info@kaptechgroup.com">info@kaptechgroup.com</a>
            </p>
         </div>
      </div>
   );
}

export default FinalStepOrg;
